import React from 'react';
import PropTypes from 'prop-types';

import fallbackImage from '-!file-loader?name=fallback.png!../../assets/images/fallback.png';

export function channelImageUrl(src) {
  if (!src) {
    return process.env.PUBLIC_URL + fallbackImage;
  }

  return [process.env.RESOURCE_ENDPOINT, 'image', src].join('/');
}

export function channelFilteredImageUrl(filterName, src) {
  if (!src) {
    return process.env.PUBLIC_URL + fallbackImage;
  }

  return [process.env.RESOURCE_ENDPOINT, 'cache', filterName, src].join('/');
}

export default function ChannelImage({src, lazy = 'eager', filter, ...rest}) {
  if (Object(src) === src) {
    src = src.path;
  }

  return (
    <img
      loading={lazy}
      src={filter ? channelFilteredImageUrl(filter, src) : channelImageUrl(src)}
      {...rest}
    />
  );
}

ChannelImage.propTypes = {
  src: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({path: PropTypes.string.isRequired}),
    PropTypes.bool
  ]).isRequired,
  filter: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string
};



// WEBPACK FOOTER //
// ./containers/channelUtils/ChannelImage.js